import React, {useState} from "react";
import RGL, {WidthProvider} from "react-grid-layout";
import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";
import dragBackground from "./drag-background.svg";
import styled from 'styled-components';
import {getSnapshot} from "mobx-state-tree";

const ReactGridLayout = WidthProvider(RGL);



const DragField = styled(ReactGridLayout)`
  margin: 16px 28px 50px 28px;
  ${props => props.isDragging ? `
    background: url(${dragBackground});
    background-repeat: repeat-y;
    background-position: 0px -4px;
    background-size: 100% 52px;
  `: ''};
`

const Dashboard = ({ children, dashboard, dashboardItems, ddinject }) => {
  console.log("db", getSnapshot(dashboard))
  const [isDragging, setIsDragging] = useState(false);
  const onLayoutChange = newLayout => {
    console.log("da", dashboard)
    console.log("la", newLayout)
    newLayout.forEach(l => {
      const item = dashboardItems.find(i => i.id.toString() === l.i);
      const toUpdate = JSON.stringify({
        x: l.x,
        y: l.y,
        w: l.w,
        h: l.h
      });

      if (item && toUpdate !== item.layout) {
        item.setLayout(toUpdate)
        dashboard.postToServer();
      }
    });
  };

  return (
    <DragField
      margin={[12, 12]}
      containerPadding={[0, 0]}
      onDragStart={() => setIsDragging(true)}
      onDragStop={() => setIsDragging(false)}
      onResizeStart={() => setIsDragging(true)}
      onResizeStop={() => setIsDragging(false)}
      cols={24}
      rowHeight={40}
      onLayoutChange={onLayoutChange}
      isDragging={isDragging}
     >
      {children}
    </DragField>
  );
};

export default Dashboard;
